export default "/5253cd0b512a66889ef5afb5e2caf631078665a1/48c3d350a874654b9919fc00f7ab5f35.png";